// extracted by mini-css-extract-plugin
export default {"areaFestival":"index_areaFestival_-Zq7-","navBar":"index_navBar_WzIiw","header":"index_header_bNs4T","areaReports":"index_areaReports_uE0ah","scene":"index_scene_9y3yU"};